/**
 * 订单状态统一文案
 */

/**
 * 订单状态orderState对应展示文案
 */
export const OrderStateToShowTxt_Map = {
  10: '待支付',
  20: {
    21: '待使用',
    22: '待服务',
    23: '待收货'
  },
  30: '待评价',
  40: '已完成',
  50: '已取消',
  70: '已过期'
}

/**
 * 订单商品skuTag对应orderState20的Map的key
 */
export const SkuTagToOrderState20Key_Map = {
  1: '22', //自营到店-待服务
  2: '22', //自营到家-待服务
  3: '22', //签约月嫂-待服务，联营月嫂(特殊处理)-待使用
  5: '23', //POP实物-待收货
  6: '21', //POP到店-待使用
  8: '21', //景点旅游601-待使用
  9: '21', //在线教育-待使用
  10: '21' //联营到家-待使用
}

/**
 * 退款状态对应展示文案
 */
export const RefundStateToShowTxt_Map = {
  10: '',
  20: '，退款中',
  30: '已取消，退款成功',
  40: '，退款失败'
}

/**
 * 上户状态对应展示文案
 */
export const WorkStateToShowTxt_Map = {
  0: '待上户',
  30: '待上户',
  35: '待上户',
  40: '服务中'
}
